import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const input = "w-full h-12 rounded-xl border border-[#EADEC9] bg-white px-3 text-base focus:outline-none focus:ring-2 focus:ring-[#1DB99A]";

export default function StartBusinessDialog({ open, onOpenChange, idea }) {
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", kind: idea?.tags?.product ? "product" : "service", budget: "", hours_per_week: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/businesses", { ...f, idea_number: idea.number, category: idea.category, name: f.name || idea.name });
      toast.success("Your business is ready. Let's build it!");
      nav("/");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-3xl bg-[#FBF8F2] border-[#EADEC9]" data-testid="start-business-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-extrabold">Let's start your business</DialogTitle>
          <DialogDescription>Just a few questions. The rest builds up as you learn.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div className="rounded-xl bg-white border border-[#EADEC9] p-3">
            <div className="text-[11px] font-semibold text-[#8C9BA5]">Business idea · {idea?.category}</div>
            <div className="font-bold">{idea?.name}</div>
          </div>
          <label className="block"><span className="text-xs font-semibold text-[#5C6B73]">Working business name</span>
            <input className={input + " mt-1"} placeholder={idea?.name} value={f.name} onChange={set("name")} data-testid="start-business-name-input" /></label>
          <div className="grid grid-cols-2 gap-2" data-testid="start-business-kind">
            {[["service", "Service"], ["product", "Product"]].map(([k, l]) => (
              <button type="button" key={k} onClick={() => setF({ ...f, kind: k })} data-testid={`start-business-kind-${k}`}
                className={`min-h-[44px] rounded-xl border text-sm font-semibold ${f.kind === k ? "border-[#1DB99A] bg-[#E8F8F4] text-[#179B80]" : "border-[#EADEC9] bg-white"}`}>{l}</button>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-3">
            <label className="block"><span className="text-xs font-semibold text-[#5C6B73]">Budget available</span>
              <input className={input + " mt-1"} placeholder="Rs 10,000" value={f.budget} onChange={set("budget")} data-testid="start-business-budget-input" /></label>
            <label className="block"><span className="text-xs font-semibold text-[#5C6B73]">Hours per week</span>
              <input className={input + " mt-1"} placeholder="8" value={f.hours_per_week} onChange={set("hours_per_week")} data-testid="start-business-hours-input" /></label>
          </div>
          <button className="sb-btn-primary w-full" disabled={busy} data-testid="start-business-submit-btn">{busy ? "Creating…" : "Start building"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
